/**
 *
 * ModalSelectLeadership
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { Modal, Button, Input, Table } from "antd"
import { get, flatMap, filter, uniq } from "lodash"
import { columns } from "./columns"
import "./index.less"
import { SearchOutlined } from "@ant-design/icons"

/* eslint-disable react/prefer-stateless-function */
class ModalSelectLeadership extends React.Component {
  state = {
    searchCollaborator: "",
    isLoadingSelectRecipients: false,
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  searchCollaborator = () => {
    const { searchCollaborator } = this.state
    const team = get(this.props.leaderSelected, "team", []) || []

    if (searchCollaborator) {
      return team.filter(({ employee_first_name, employee_last_name }) => {
        return (
          employee_first_name
            .toLowerCase()
            .includes(searchCollaborator.toLocaleLowerCase()) ||
          employee_last_name
            .toLowerCase()
            .includes(searchCollaborator.toLocaleLowerCase())
        )
      })
    }

    return team
  }

  render() {
    const { searchCollaborator } = this.state
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        const newEmployees = [...this.props.employees]
        const previousEmployees = this.props.leaderSelected.team.map(
          (item) => item.employee_id
        )

        const toDelete = new Set(previousEmployees)
        const newArray = newEmployees.filter((item) => !toDelete.has(item))

        const finalEmployees = uniq(newArray.concat(selectedRowKeys))
        this.setState({ isLoadingSelectRecipients: true })
        setTimeout(
          () => this.setState({ isLoadingSelectRecipients: false }),
          1000
        )

        const employeesIds = flatMap(
          this.props.leaderSelected.team,
          (item) => item.employee_id
        )
        const hasAllEmployees = filter(selectedRowKeys, (item) =>
          employeesIds.includes(item)
        )

        if (this.props.leaderSelected.team.length === hasAllEmployees.length) {
          this.props.setStateFrom("leaders", [
            ...this.props.leaders,
            this.props.leaderSelected.id_employee,
          ])
        }

        if (!hasAllEmployees.length) {
          const filterLeaders = filter(
            this.props.leaders,
            (leader) => leader !== this.props.leaderSelected.id_employee
          )
          this.props.setStateFrom("leaders", filterLeaders)
        }

        this.props.setStateFrom("employees", finalEmployees)
      },
      getCheckboxProps: (record) => {
        return {
          disabled:
            this.props.leaderSelected.team.length <= this.props.anonymity,
          name: record.name,
        }
      },
      selectedRowKeys: this.props.employees,
    }

    return (
      <Modal
        title={
          <div>
            Editar equipo de{" "}
            <strong>
              {get(this.props.leaderSelected, "employee_full_name", "")}
            </strong>
          </div>
        }
        className="modal-select-leader modal-select-leadership"
        width={650}
        style={{ top: 76 }}
        visible={this.props.visible}
        onCancel={() => this.props.setStateFrom("modalSelectLeadership", false)}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              this.props.setStateFrom("modalSelectLeadership", false)
            }}>
            Cerrar
          </Button>,
        ]}>
        <div className="modal-select-leadership-header">
          <Input
            className="modal-select-leadership-input"
            style={{ width: 308 }}
            allowClear
            placeholder="Buscar..."
            value={searchCollaborator}
            suffix={!searchCollaborator && <SearchOutlined />}
            onChange={(e) =>
              this.setState({ searchCollaborator: e.target.value })
            }
          />
          <span>
            {(get(this.props.leaderSelected, "team", []) || []).length}{" "}
            colaboradores
          </span>
        </div>
        <Table
          bordered
          className="select-leadership-recipients-table modal-select-lidership-table"
          dataSource={this.searchCollaborator()}
          rowKey={(record) => record.employee_id}
          rowSelection={rowSelection}
          columns={columns()}
          loading={this.state.isLoadingSelectRecipients}
          pagination={{
            pageSizeOptions: ["15", "25", "50", "100"],
            showSizeChanger: true,
            size: "default",
            defaultPageSize: 15,
          }}
        />
      </Modal>
    )
  }
}

ModalSelectLeadership.propTypes = {}

export default ModalSelectLeadership
